/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truckin-trans': {
    width: 10,
    height: 9,
    viewBox: '0 0 10 9',
    data: '<path pid="0" _fill="#376F99" fill-rule="nonzero" d="M5.267.267l-.934.933 2.4 2.4h-6v1.333h6l-2.4 2.4.934.934 4-4z"/>'
  }
})
